module.exports = __webpack_public_path__ + "static/media/ConsultasYReclamos.723d6f1c.jpg";